import { TAbUseExperimentsState } from '../../types/abUseExperiments/abUseExperiments';

export const abUseExperimentsReducer = (state: TAbUseExperimentsState = []) => state;
